import useFetchFile from '#/useFetchFile';
import { useEffect, useState } from 'react';
import { Spinner, Image } from 'react-bootstrap';
let loadCount = 0;
const AsyncImage = (props) => {

  const {
    fileLoad,
    fileData,
    makeFetchRequest,
    setFileData
  } = useFetchFile();
  const [errorCount, setErrorCount] = useState(0);
  const {
    spinnerStyle = {},
    path,
    spinnerSize = 36,
    style = {},
    imageClassName,
    defaultImage,
    roundedCircle,
    alt = 'DSS Product Image'
  } = props;
  // if (!path) return null;
  useEffect(() => {
    makeFetchRequest(path)
    // .catch(er => {defaultImage && setFileData(defaultImage)})
  }, [path])

return (
  <>
    {
      fileLoad ?
        <div style={{ position: 'relative' }}>
          <Spinner
            animation='border'
            style={{
              ...spinnerStyle,
              color: '#c2291d',
              position: 'absolute',
              left: '30%'
            }}
            size={spinnerSize || 36}
          />
        </div>
        :
        <img
          key={`${fileData}_${errorCount}`}
          alt={alt}
          src={fileData || defaultImage}
          className={imageClassName}
          style={style}
          // refresh image component every 3 seconds if load fails
          onError={() => { setTimeout(() => setErrorCount(prev => prev + 1),3000 + (loadCount++) * 1000)}}
        />
    }
  </>
)
}
export default AsyncImage;